import React from 'react';
import { siteData } from '../data/site';
import logo from '../assets/logo volantin.png';

const MapPinIcon = () => (
  <svg className="w-4 h-4 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 0115 0z" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
  </svg>
);

const MailIcon = () => (
  <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Inicio', href: 'inicio' },
    { name: 'Quiénes Somos', href: 'quienes-somos' },
    { name: 'Equipo', href: 'equipo' },
    { name: 'Servicios', href: 'servicios' },
    { name: 'Testimonios', href: 'testimonios' },
    { name: 'Blog', href: 'blog' },
    { name: 'Contacto', href: 'contacto' },
  ];

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-text text-white/80">
      {/* Top wave decoration */}
      <div className="h-2 bg-gradient-to-r from-primary via-secondary to-background" />

      <div className="container-custom py-14">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">

          {/* Brand column */}
          <div className="lg:col-span-1 space-y-5">
            <button
              onClick={() => scrollToSection('inicio')}
              className="flex items-center gap-3 cursor-pointer group"
            >
              <img src={logo} alt="Logo Centro Volantín" className="w-12 h-12 object-contain" />
              <span className="font-fredoka text-2xl text-white group-hover:text-secondary transition-colors">
                Centro Volantín
              </span>
            </button>
            <p className="text-white/60 leading-relaxed text-sm font-nunito">
              Acompañamiento terapéutico integral para niños y familias.
              Creciendo juntos, paso a paso.
            </p>

            {/* Social links */}
            <div className="flex gap-3">
              <a href={siteData.social.facebook} target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 bg-white/10 hover:bg-primary rounded-xl flex items-center justify-center transition-colors cursor-pointer" aria-label="Facebook">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href={siteData.social.instagram} target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 bg-white/10 hover:bg-primary rounded-xl flex items-center justify-center transition-colors cursor-pointer" aria-label="Instagram">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
              </a>
              <a href={siteData.social.youtube} target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 bg-white/10 hover:bg-primary rounded-xl flex items-center justify-center transition-colors cursor-pointer" aria-label="YouTube">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="font-fredoka text-lg text-white mb-5">Enlaces rápidos</h3>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-white/60 hover:text-secondary transition-colors text-sm font-nunito cursor-pointer"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h3 className="font-fredoka text-lg text-white mb-5">Contacto</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-2.5 text-white/60">
                <MapPinIcon />
                <p className="text-sm font-nunito">{siteData.contact.address}</p>
              </div>
              <div className="flex items-center gap-2.5">
                <span className="text-white/60"><PhoneIcon /></span>
                <a href={`tel:${siteData.contact.phone}`} className="text-white/60 hover:text-secondary text-sm font-nunito transition-colors">
                  {siteData.contact.phone}
                </a>
              </div>
              <div className="flex items-center gap-2.5">
                <span className="text-white/60"><MailIcon /></span>
                <a href={`mailto:${siteData.contact.email}`} className="text-white/60 hover:text-secondary text-sm font-nunito transition-colors">
                  {siteData.contact.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm font-nunito">
            © {currentYear} Centro Volantín. Todos los derechos reservados.
          </p>
          <div className="flex gap-5 text-sm">
            <button onClick={() => scrollToSection('contacto')} className="text-white/40 hover:text-secondary transition-colors font-nunito cursor-pointer">
              Política de privacidad
            </button>
            <button onClick={() => scrollToSection('contacto')} className="text-white/40 hover:text-secondary transition-colors font-nunito cursor-pointer">
              Términos de servicio
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
